// import { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router";
// import Cookies from "js-cookie";
// import {
//   CheckCircle,
//   Clock,
//   Edit,
//   Eye,
//   Filter,
//   MoreVertical,
//   Plus,
//   RefreshCw,
//   Search,
//   Trash2,
//   Users,
// } from "lucide-react";
// import { getMyVehicles } from "../../../services/customerVehicle.service";
// import { Seo } from "../../components/Seo";

// const apiBaseUrl = (
//   import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1"
// ).replace(/\/api\/v1\/?$/, "");
// const getImageUrl = (vehicle: any) => {
//   const images = Array.isArray(vehicle.Images) ? vehicle.Images : [];
//   const file = images[0];
//   if (!file) return "https://placehold.co/120x80?text=Vehicle";
//   return String(file).startsWith("http")
//     ? file
//     : `${apiBaseUrl}/volume/${String(file).replace(/^\/+/, "")}`;
// };
// const getStatus = (vehicle: any) => (vehicle.IsActive ? "active" : "draft");
// const statusConfig: Record<
//   string,
//   { label: string; className: string; Icon: any }
// > = {
//   active: {
//     label: "Active",
//     className: "bg-[#22C55E]/10 text-[#22C55E]",
//     Icon: CheckCircle,
//   },
//   draft: {
//     label: "Draft",
//     className: "bg-[#E5E7EB] text-[#717182]",
//     Icon: Edit,
//   },
//   pending: {
//     label: "Under Review",
//     className: "bg-[#F59E0B]/10 text-[#F59E0B]",
//     Icon: Clock,
//   },
// };

// export function MyListings() {
//   const [listings, setListings] = useState<any[]>([]);
//   const [filter, setFilter] = useState("all");
//   const [search, setSearch] = useState("");
//   const [openMenu, setOpenMenu] = useState<string | null>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const addPath =
//     Number(Cookies.get("customerType")) === 3
//       ? "/dealer/add-vehicle"
//       : "/dashboard/add-vehicle";

//   useEffect(() => {
//     getMyVehicles()
//       .then((result) => setListings(result.data || []))
//       .catch((requestError: any) =>
//         setError(
//           requestError.response?.data?.message || "Unable to load listings",
//         ),
//       )
//       .finally(() => setLoading(false));
//   }, []);

//   const filtered = useMemo(
//     () =>
//       listings.filter((vehicle) => {
//         const title = String(
//           vehicle.Title || vehicle.Category || "",
//         ).toLowerCase();
//         return (
//           (filter === "all" || getStatus(vehicle) === filter) &&
//           (!search || title.includes(search.toLowerCase()))
//         );
//       }),
//     [filter, listings, search],
//   );

//   return (
//     <div className="p-4 md:p-8">
//       <Seo
//         title="My Listings"
//         description="Manage your MORROCARS vehicle listings."
//       />
//       <div className="flex items-center justify-between mb-6">
//         <div>
//           <h1 className="text-2xl text-[#2D323A]">My Listings</h1>
//           <p className="text-[#717182]">{listings.length} total vehicles</p>
//         </div>
//         <Link
//           to={addPath}
//           className="flex items-center gap-2 px-5 py-2.5 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors shadow-md"
//         >
//           <Plus className="w-5 h-5" /> Add Vehicle
//         </Link>
//       </div>
//       <div className="flex flex-col sm:flex-row gap-3 mb-5">
//         <div className="relative flex-1">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#717182]" />
//           <input
//             value={search}
//             onChange={(event) => setSearch(event.target.value)}
//             placeholder="Search listings..."
//             className="w-full pl-10 pr-4 py-2.5 bg-white border border-[#E5E7EB] rounded-xl focus:outline-none focus:border-[#1E6DFF] text-sm"
//           />
//         </div>
//         <div className="flex gap-1 bg-white border border-[#E5E7EB] rounded-xl p-1">
//           {["all", "active", "pending", "draft"].map((value) => (
//             <button
//               key={value}
//               onClick={() => setFilter(value)}
//               className={`px-3 py-1.5 rounded-lg text-sm capitalize transition-colors ${filter === value ? "bg-[#1E6DFF] text-white" : "text-[#717182] hover:bg-[#F5F7FA]"}`}
//             >
//               {value}
//             </button>
//           ))}
//         </div>
//       </div>
//       {loading ? (
//         <div className="rounded-2xl border bg-white p-12 text-center text-[#717182]">
//           Loading listings...
//         </div>
//       ) : error ? (
//         <div className="rounded-2xl border bg-white p-12 text-center text-red-600">
//           {error}
//         </div>
//       ) : filtered.length === 0 ? (
//         <div className="bg-white rounded-2xl border border-[#E5E7EB] p-12 text-center">
//           <Filter className="w-7 h-7 text-[#BFC2C7] mx-auto mb-3" />
//           <p className="text-[#717182]">No listings match your filter</p>
//         </div>
//       ) : (
//         <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-visible">
//           <div className="hidden md:grid grid-cols-[auto_1fr_auto_auto_auto_auto_auto] gap-4 px-5 py-3 bg-[#F5F7FA] border-b border-[#E5E7EB] text-xs text-[#717182]">
//             <span>Photo</span>
//             <span>Vehicle</span>
//             <span>Price</span>
//             <span>Views</span>
//             <span>Leads</span>
//             <span>Status</span>
//             <span>Actions</span>
//           </div>
//           <div className="divide-y divide-[#E5E7EB]">
//             {filtered.map((vehicle) => {
//               const status = statusConfig[getStatus(vehicle)];
//               const StatusIcon = status.Icon;
//               return (
//                 <div
//                   key={vehicle.id}
//                   className="flex flex-col md:grid md:grid-cols-[auto_1fr_auto_auto_auto_auto_auto] gap-4 items-start md:items-center px-5 py-4"
//                 >
//                   <img
//                     src={getImageUrl(vehicle)}
//                     alt={vehicle.Title || "Vehicle"}
//                     className="w-20 h-14 rounded-xl object-cover"
//                   />
//                   <div>
//                     <p className="text-sm text-[#2D323A]">
//                       {vehicle.Title || vehicle.Category || "Vehicle listing"}
//                     </p>
//                     <p className="text-xs text-[#717182]">
//                       {vehicle.YearOfRegistration || "—"} ·{" "}
//                       {vehicle.Mileage
//                         ? `${Number(vehicle.Mileage).toLocaleString()} km`
//                         : "—"}
//                     </p>
//                   </div>
//                   <span className="text-sm text-[#2D323A]">
//                     {vehicle.Price
//                       ? `${Number(vehicle.Price).toLocaleString()} MAD`
//                       : "Price on request"}
//                   </span>
//                   <span className="text-sm text-[#717182] flex items-center gap-1">
//                     <Eye className="w-3 h-3" />0
//                   </span>
//                   <span className="text-sm text-[#717182] flex items-center gap-1">
//                     <Users className="w-3 h-3" />0
//                   </span>
//                   <span
//                     className={`text-xs px-2 py-1 rounded-lg flex items-center gap-1 ${status.className}`}
//                   >
//                     <StatusIcon className="w-3 h-3" />
//                     {status.label}
//                   </span>
//                   <div className="relative">
//                     <button
//                       onClick={() =>
//                         setOpenMenu(openMenu === vehicle.id ? null : vehicle.id)
//                       }
//                       className="p-2 hover:bg-[#F5F7FA] rounded-xl"
//                     >
//                       <MoreVertical className="w-4 h-4 text-[#717182]" />
//                     </button>
//                     {openMenu === vehicle.id && (
//                       <div className="absolute right-0 mt-1 w-36 bg-white border border-[#E5E7EB] rounded-xl shadow-lg py-1 z-10">
//                         <Link
//                           to={`/vehicle/${vehicle.id}`}
//                           className="flex items-center gap-2 px-3 py-2 text-sm text-[#2D323A] hover:bg-[#F5F7FA]"
//                         >
//                           <Eye className="w-4 h-4" /> View
//                         </Link>
//                         <Link
//                           to={`${Number(Cookies.get("customerType")) === 3 ? "/dealer/inventory" : "/dashboard/listings"}/${vehicle.id}/edit`}
//                           className="flex items-center gap-2 px-3 py-2 text-sm text-[#2D323A] hover:bg-[#F5F7FA]"
//                         >
//                           <Edit className="w-4 h-4" /> Edit
//                         </Link>
//                         <button
//                           disabled
//                           title="Renewal is not part of the current scope"
//                           className="flex w-full items-center gap-2 px-3 py-2 text-sm text-[#1E6DFF] opacity-50 cursor-not-allowed"
//                         >
//                           <RefreshCw className="w-4 h-4" /> Renew
//                         </button>
//                         <hr className="my-1 border-[#E5E7EB]" />
//                         <button
//                           disabled
//                           title="Delete is not part of the current scope"
//                           className="flex w-full items-center gap-2 px-3 py-2 text-sm text-[#EF4444] opacity-50 cursor-not-allowed"
//                         >
//                           <Trash2 className="w-4 h-4" /> Delete
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
// src/pages/dashboard/MyListings.tsx
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { useTranslation } from 'react-i18next'; 
import Cookies from "js-cookie";
import {
  CheckCircle,
  Clock,
  Edit,
  Eye,
  Filter,
  MoreVertical,
  Plus,
  RefreshCw,
  Search,
  Trash2,
  Users,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { getMyVehicles, CustomerVehiclePagination } from "../../../services/customerVehicle.service";
import { Seo } from "../../components/Seo";

const apiBaseUrl = (
  import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1"
).replace(/\/api\/v1\/?$/, "");
const getImageUrl = (vehicle: any) => {
  const images = Array.isArray(vehicle.Images) ? vehicle.Images : [];
  const file = images[0];
  if (!file) return "https://placehold.co/120x80?text=Vehicle";
  return String(file).startsWith("http")
    ? file
    : `${apiBaseUrl}/volume/${String(file).replace(/^\/+/, "")}`;
};
const getStatus = (vehicle: any) => (vehicle.IsActive ? "active" : "draft");

export function MyListings() {
  const { t } = useTranslation('auth'); 
  const [listings, setListings] = useState<any[]>([]);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<CustomerVehiclePagination | null>(null);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const addPath =
    Number(Cookies.get("customerType")) === 3
      ? "/dealer/add-vehicle"
      : "/dashboard/add-vehicle";

  // ✅ Status config with translations
  const getStatusConfig = (status: string) => {
    const configs: Record<
      string,
      { label: string; className: string; Icon: any }
    > = {
      active: {
        label: t('listings.status.active'),
        className: "bg-[#22C55E]/10 text-[#22C55E]",
        Icon: CheckCircle,
      },
      draft: {
        label: t('listings.status.draft'),
        className: "bg-[#E5E7EB] text-[#717182]",
        Icon: Edit,
      },
      pending: {
        label: t('listings.status.pending'),
        className: "bg-[#F59E0B]/10 text-[#F59E0B]",
        Icon: Clock,
      },
    };
    return configs[status] || configs.draft;
  };

  useEffect(() => {
    setLoading(true);
    getMyVehicles({ page, pageSize: 10 })
      .then((result) => {
        setListings(result.data || []);
        if (result.pagination) setPagination(result.pagination);
      })
      .catch((requestError: any) =>
        setError(
          requestError.response?.data?.message || t('listings.error'),
        ),
      )
      .finally(() => setLoading(false));
  }, [page]);

  const filtered = useMemo(
    () =>
      listings.filter((vehicle) => {
        const title = String(
          vehicle.Title || vehicle.Category || "",
        ).toLowerCase();
        return (
          (filter === "all" || getStatus(vehicle) === filter) &&
          (!search || title.includes(search.toLowerCase()))
        );
      }),
    [filter, listings, search],
  );

  // Filter options with translations
  const filterOptions = [
    { value: "all", label: t('listings.filters.all') },
    { value: "active", label: t('listings.filters.active') },
    { value: "pending", label: t('listings.filters.pending') },
    { value: "draft", label: t('listings.filters.draft') },
  ];

  return (
    <div className="p-4 md:p-8">
      <Seo
        title={t('listings.seo.title')}
        description={t('listings.seo.description')}
      />
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl text-[#2D323A]">{t('listings.title')}</h1>
          <p className="text-[#717182]">{(pagination ? pagination.total_records : listings.length)} {t('listings.subtitle')}</p>
        </div>
        <Link
          to={addPath}
          className="flex items-center gap-2 px-5 py-2.5 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors shadow-md"
        >
          <Plus className="w-5 h-5" /> {t('listings.addVehicle')}
        </Link>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mb-5">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#717182]" />
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder={t('listings.searchPlaceholder')}
            className="w-full pl-10 pr-4 py-2.5 bg-white border border-[#E5E7EB] rounded-xl focus:outline-none focus:border-[#1E6DFF] text-sm"
          />
        </div>
        <div className="flex gap-1 bg-white border border-[#E5E7EB] rounded-xl p-1">
          {filterOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => setFilter(option.value)}
              className={`px-3 py-1.5 rounded-lg text-sm capitalize transition-colors ${
                filter === option.value
                  ? "bg-[#1E6DFF] text-white"
                  : "text-[#717182] hover:bg-[#F5F7FA]"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="rounded-2xl border bg-white p-12 text-center text-[#717182]">
          {t('listings.loading')}
        </div>
      ) : error ? (
        <div className="rounded-2xl border bg-white p-12 text-center text-red-600">
          {error}
        </div>
      ) : filtered.length === 0 ? (
        <div className="bg-white rounded-2xl border border-[#E5E7EB] p-12 text-center">
          <Filter className="w-7 h-7 text-[#BFC2C7] mx-auto mb-3" />
          <p className="text-[#717182]">{t('listings.empty.title')}</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-visible">
          <div className="hidden md:grid grid-cols-[auto_1fr_auto_auto_auto_auto_auto] gap-4 px-5 py-3 bg-[#F5F7FA] border-b border-[#E5E7EB] text-xs text-[#717182]">
            <span>{t('listings.table.photo')}</span>
            <span>{t('listings.table.vehicle')}</span>
            <span>{t('listings.table.price')}</span>
            <span>{t('listings.table.views')}</span>
            <span>{t('listings.table.leads')}</span>
            <span>{t('listings.table.status')}</span>
            <span>{t('listings.table.actions')}</span>
          </div>
          <div className="divide-y divide-[#E5E7EB]">
            {filtered.map((vehicle) => {
              const status = getStatusConfig(getStatus(vehicle));
              const StatusIcon = status.Icon;
              return (
                <div
                  key={vehicle.id}
                  className="flex flex-col md:grid md:grid-cols-[auto_1fr_auto_auto_auto_auto_auto] gap-4 items-start md:items-center px-5 py-4"
                >
                  <img
                    src={getImageUrl(vehicle)}
                    alt={vehicle.Title || "Vehicle"}
                    className="w-20 h-14 rounded-xl object-cover"
                  />
                  <div>
                    <p className="text-sm text-[#2D323A]">
                      {vehicle.Title || vehicle.Category || "Vehicle listing"}
                    </p>
                    <p className="text-xs text-[#717182]">
                      {vehicle.YearOfRegistration || "—"} ·{" "}
                      {vehicle.Mileage
                        ? `${Number(vehicle.Mileage).toLocaleString()} km`
                        : "—"}
                    </p>
                  </div>
                  <span className="text-sm text-[#2D323A]">
                    {vehicle.Price
                      ? `${Number(vehicle.Price).toLocaleString()} MAD`
                      : t('priceOnRequest')}
                  </span>
                  <span className="text-sm text-[#717182] flex items-center gap-1">
                    <Eye className="w-3 h-3" />{Number(vehicle.ViewCount || 0).toLocaleString()}
                  </span>
                  <span className="text-sm text-[#717182] flex items-center gap-1">
                    <Users className="w-3 h-3" />{Number(vehicle.LeadCount || 0).toLocaleString()}
                  </span>
                  <span
                    className={`text-xs px-2 py-1 rounded-lg flex items-center gap-1 ${status.className}`}
                  >
                    <StatusIcon className="w-3 h-3" />
                    {status.label}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() =>
                        setOpenMenu(openMenu === vehicle.id ? null : vehicle.id)
                      }
                      className="p-2 hover:bg-[#F5F7FA] rounded-xl"
                    >
                      <MoreVertical className="w-4 h-4 text-[#717182]" />
                    </button>
                    {openMenu === vehicle.id && (
                      <div className="absolute right-0 mt-1 w-36 bg-white border border-[#E5E7EB] rounded-xl shadow-lg py-1 z-10">
                        <Link
                          to={`/vehicle/${vehicle.id}`}
                          className="flex items-center gap-2 px-3 py-2 text-sm text-[#2D323A] hover:bg-[#F5F7FA]"
                        >
                          <Eye className="w-4 h-4" /> {t('listings.menu.view')}
                        </Link>
                        <Link
                          to={`${
                            Number(Cookies.get("customerType")) === 3
                              ? "/dealer/inventory"
                              : "/dashboard/listings"
                          }/${vehicle.id}/edit`}
                          className="flex items-center gap-2 px-3 py-2 text-sm text-[#2D323A] hover:bg-[#F5F7FA]"
                        >
                          <Edit className="w-4 h-4" /> {t('listings.menu.edit')}
                        </Link>
                        <button
                          disabled
                          title={t('listings.menu.renewDisabled')}
                          className="flex w-full items-center gap-2 px-3 py-2 text-sm text-[#1E6DFF] opacity-50 cursor-not-allowed"
                        >
                          <RefreshCw className="w-4 h-4" /> {t('listings.menu.renew')}
                        </button>
                        <hr className="my-1 border-[#E5E7EB]" />
                        <button
                          disabled
                          title={t('listings.menu.deleteDisabled')}
                          className="flex w-full items-center gap-2 px-3 py-2 text-sm text-[#EF4444] opacity-50 cursor-not-allowed"
                        >
                          <Trash2 className="w-4 h-4" /> {t('listings.menu.delete')}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {pagination && pagination.total_pages > 1 && (
        <div className="flex items-center justify-center gap-2 mt-6">
          <button
            onClick={() => setPage((prev) => Math.max(1, prev - 1))}
            disabled={pagination.page_number <= 1}
            className="flex items-center justify-center w-10 h-10 border border-[#E5E7EB] rounded-xl bg-white text-sm font-medium text-[#2D323A] disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#F5F7FA] transition-colors cursor-pointer"
            aria-label="Previous page"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
          {Array.from({ length: pagination.total_pages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className={`w-10 h-10 rounded-xl text-sm font-medium transition-colors cursor-pointer ${
                p === pagination.page_number
                  ? 'bg-[#1E6DFF] text-white shadow-sm'
                  : 'bg-white border border-[#E5E7EB] text-[#2D323A] hover:bg-[#F5F7FA]'
              }`}
            >
              {p}
            </button>
          ))}
          <button
            onClick={() => setPage((prev) => Math.min(pagination.total_pages, prev + 1))}
            disabled={pagination.page_number >= pagination.total_pages}
            className="flex items-center justify-center w-10 h-10 border border-[#E5E7EB] rounded-xl bg-white text-sm font-medium text-[#2D323A] disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#F5F7FA] transition-colors cursor-pointer"
            aria-label="Next page"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
}
